export const getUserRolePermissions = (userRolePermissions) => ({
  viewUserBtn: userRolePermissions.includes('view_user'),
  createUserBtn: userRolePermissions.includes('create_user'),
  editUserBtn: userRolePermissions.includes('edit_user'),
  deleteUserBtn: userRolePermissions.includes('delete_user'),
});

export const getAddressRolePermissions = (addressRolePermissions) => ({
  viewAddressBtn: addressRolePermissions.includes('view_address'),
  createAddressBtn: addressRolePermissions.includes('create_address'),
  editAddressBtn: addressRolePermissions.includes('edit_address'),
  deleteAddressBtn: addressRolePermissions.includes('delete_address'),
});

export const getOrderRolePermissions = (orderRolePermissions) => ({
  viewOrderBtn: orderRolePermissions.includes('view_order'),
  createOrderBtn: orderRolePermissions.includes('create_order'),
  editOrderBtn: orderRolePermissions.includes('edit_order'),
  deleteOrderBtn: orderRolePermissions.includes('delete_order'),
});

export const getProductsRolePermissions = (productRolePermissions) => ({
  viewProductBtn: productRolePermissions.includes('view_product'),
  createProductBtn: productRolePermissions.includes('create_product'),
  editProductBtn: productRolePermissions.includes('edit_product'),
  deleteProductBtn: productRolePermissions.includes('delete_product'),
});
